import type { Reunion } from '@/types/types';
import { api } from './api';

export interface CrearReunionRequest {
  inicio: string;
  fin: string;
  motivo?: string;
  link?: string;
  companyEmail?: string;
}

export interface CrearReunionResponse {
  success: boolean;
  reunion: Reunion;
}

export interface ReunionesResponse {
  success: boolean;
  reuniones: Reunion[];
  message?: string;
}

export interface ActualizarReunionRequest {
  inicio?: string;
  fin?: string;
  motivo?: string;
}

export interface ActualizarReunionResponse {
  success: boolean;
  reunion: Reunion;
}

export const reunionesService = {
  async getByAsesoriaActual(nit: string): Promise<ReunionesResponse> {
    return api.get<ReunionesResponse>(`/empresas/${nit}/asesoria-activa/reuniones`);
  },

  async crear(nit: string, payload: CrearReunionRequest): Promise<CrearReunionResponse> {
    return api.post<CrearReunionResponse>(`/empresas/${nit}/asesoria-activa/reuniones`, payload);
  },

  async actualizarDeAsesoriaActual(reunionId: string, nit: string, payload: ActualizarReunionRequest): Promise<ActualizarReunionResponse> {
    return api.patch<ActualizarReunionResponse>(`/empresas/${nit}/asesoria-activa/reuniones/${reunionId}`, payload);
  },

  async completarDeAsesoriaActual(reunionId: string, nit: string): Promise<ActualizarReunionResponse> {
    return api.patch<ActualizarReunionResponse>(`/empresas/${nit}/asesoria-activa/reuniones/${reunionId}/estado`, {});
  },

  async cancelarDeAsesoriaActual(reunionId: string, nit: string): Promise<ActualizarReunionResponse> {
    return api.delete<ActualizarReunionResponse>(`/empresas/${nit}/asesoria-activa/reuniones/${reunionId}`);
  },
};
